import React from 'react';

const MainFooter = (props) => {
  return <>
    <footer>
        <div className="container">
            <div className="ftTnc text-center">
                <ul>
                    <li><a href={`${process.env.REACT_APP_URL}terms-of-service.html`}>Terms & Conditions</a></li>
                    <li><a href={`${process.env.REACT_APP_URL}privacy-policy.html`}>Privacy Policy</a></li>
                    <li><a href={`${process.env.REACT_APP_URL}refund-policy.html`}>Refund Policy</a></li>                    
                    <li><a href={`${process.env.REACT_APP_URL}about-us.html`}>About Us</a></li>
                    <li><a href={`${process.env.REACT_APP_URL}contact-us.html`}>Contact Us</a></li>
                </ul>
                 
            </div>
            <div className="bylink"> 
                <a href="https://svasu.cloud/" className="cta">SVASU.cloud</a><span style={{color:"black", fontWeight:"bolder"}} >By</span>
                <a href="https://knowledgesynonyms.com" className="cta" target="_blank"> Knowledge Synonyms </a>
            </div>
            <div className="socialMedia">
                <ul>
                    <li><a href="https://www.facebook.com/SVASU.cloud/" target="_blank"><img src={`${process.env.PUBLIC_URL}/images/fb.png`}
                                alt="Svasu Facebook" /></a></li>
                    <li><a href="https://twitter.com/SVASUCLOUD" target="_blank"><img src={`${process.env.PUBLIC_URL}/images/tw.png`}
                                alt="Svasu Twitter" /></a></li>
                    <li><a href="https://www.instagram.com/svasu.cloud/" target="_blank"><img src={`${process.env.PUBLIC_URL}/images/ig.png`}
                                alt="Svasu Instagram" /></a></li>
                    <li><a href="https://www.linkedin.com/company/svasu%E2%84%A2/" target="_blank"><img
                                src={`${process.env.PUBLIC_URL}/images/in.png`} alt="Svasu LinkedIn" /></a></li>
                </ul>
            </div>
            
            <span class="spCertificate">
                <img className="" src={`${process.env.PUBLIC_URL}/images/svasu_iso.png`} alt="svasu-iso" />
                <span className="copy">&copy; 2022 SVASU. All right reserved.</span>
            </span>
        </div>
    </footer>
  </>
}

export default MainFooter;